class AcyrosDetailsGroup extends HTMLElement {
  connectedCallback() {
    this.addEventListener('toggle', this.handleToggle, true);
  }

  disconnectedCallback() {
    this.removeEventListener('toggle', this.handleToggle, true);
  }

  handleToggle = (event) => {
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;

    this.querySelectorAll('details[open]').forEach((item) => {
      if (item !== opened) item.open = false;
    });
  };
}

if (!customElements.get('acyros-details-group')) {
  customElements.define('acyros-details-group', AcyrosDetailsGroup);
}

/* v25 — Back-to-top: appears after scrolling, smooth return, respects reduced motion.
   v25.1 — Das Theme scrollt je nach Layout nicht im Fenster, sondern in
   .page-wrapper. Dann bleibt window.scrollY auf 0 und am window feuert kein
   scroll-Event, weshalb der Button nie erschien. Scroll-Events steigen nicht
   auf, laufen aber durch die Capture-Phase von document — daher wird dort
   gelauscht, und die Position aus dem tatsächlich scrollenden Element gelesen. */
(function () {
  var btn = document.querySelector('[data-acyros-top]');
  if (!btn) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var scroller = function () {
    var candidates = [
      document.querySelector('.page-wrapper'),
      document.getElementById('MainContent'),
      document.querySelector('main'),
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] && candidates[i].scrollTop > 0) return candidates[i];
    }
    return null;
  };

  var offset = function () {
    var win = window.scrollY || document.documentElement.scrollTop || 0;
    if (win > 0) return win;
    var el = scroller();
    return el ? el.scrollTop : 0;
  };

  var onScroll = function () {
    btn.classList.toggle('is-visible', offset() > 600);
  };

  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  btn.addEventListener('click', function () {
    var opts = { top: 0, behavior: reduce ? 'auto' : 'smooth' };
    var el = scroller();
    if (el) el.scrollTo(opts);
    else window.scrollTo(opts);
  });
})();

/* v25.1 — Warenkorb-Countdown auf den täglichen Versand-Cutoff.
   Läuft gegen einen echten Stichtag, nicht gegen eine erfundene Frist:
   Solange die Uhr läuft, geht die Bestellung heute noch raus. Nach dem Cutoff
   wird auf den nächsten Werktag umgestellt und der Text entsprechend geändert.
   Ein global laufendes Intervall aktualisiert alle vorhandenen Timer, damit es
   auch nach einem Neu-Rendern des Cart-Drawers ohne erneute Initialisierung
   weiterläuft. */
(function () {
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

  var nextCutoff = function (hour, minute) {
    var now = new Date();
    var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, 0, 0);
    var passed = now >= target;
    if (passed) target.setDate(target.getDate() + 1);
    // Wochenenden überspringen: Samstag (6) und Sonntag (0) sind keine Versandtage.
    while (target.getDay() === 0 || target.getDay() === 6) {
      target.setDate(target.getDate() + 1);
      passed = true;
    }
    return { target: target, sameDay: !passed };
  };

  var render = function (el) {
    var hour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    var minute = parseInt(el.getAttribute('data-cutoff-minute'), 10);
    if (isNaN(hour)) hour = 14;
    if (isNaN(minute)) minute = 0;

    var info = nextCutoff(hour, minute);
    var diff = Math.max(0, Math.floor((info.target - new Date()) / 1000));
    var h = Math.floor(diff / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;

    var value = el.querySelector('[data-timer-value]');
    var suffix = el.querySelector('[data-timer-suffix]');
    if (!value) return;

    var label = el.querySelector('[data-timer-label]');

    if (h >= 12) {
      // Mehr als ein halber Tag bis zum Cutoff (Wochenende oder später Abend):
      // eine große Stundenzahl wirkt hier befremdlich statt dringlich.
      // Dann lieber den nächsten Versandtag benennen.
      var days = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
      if (label) label.textContent = 'Jetzt bestellen —';
      value.textContent = 'Versand ' + days[info.target.getDay()];
      if (suffix) suffix.textContent = 'dein Paket ist dann schon vorbereitet';
    } else {
      if (label) label.textContent = 'Noch';
      value.textContent = h > 0 ? h + ':' + pad(m) + ' h' : pad(m) + ':' + pad(s) + ' min';
      if (suffix) {
        suffix.textContent = info.sameDay
          ? 'bestellen, dann geht dein Paket heute raus'
          : 'bis zum nächsten Versand';
      }
    }
    el.hidden = false;
  };

  var tick = function () {
    var nodes = document.querySelectorAll('[data-acyros-cart-timer]');
    for (var i = 0; i < nodes.length; i++) render(nodes[i]);
  };

  tick();
  setInterval(tick, 1000);
  document.addEventListener('cart:update', tick);
})();
